const AdditionalSalesSecretButton = ({ onClick, style }) => {
  return (
    <button
      style={{
        opacity: '0',
        width: '30em',
        height: '15em',
        position: 'absolute',
        right: '0',
        top: '0',
        cursor: 'none',
        ...style,
      }}
      onClick={onClick}
    ></button>
  )
}

export default AdditionalSalesSecretButton
